import fetch from 'isomorphic-fetch'

import {
  API_URL,
  ENDPOINT_VISU_EXHIBITION,
  ENDPOINT_VISU_EXHIBITION_ADDRESS,
  ENDPOINT_VISU_EXHIBITION_SECTION,
  ENDPOINT_VISU_EXHIBITION_SECTION_CSV,
  ENDPOINT_VISU_EXHIBITOR,
  ENDPOINT_VISU_EXHIBITED_WORK,
  ENDPOINT_VISU_EXHIBITED_WORK_CSV,
  ENDPOINT_VISU_EXHIBITION_GROUP_TYPE,
  ENDPOINT_VISU_EXHIBITION_GROUP,
  ENDPOINT_VISU_EXHIBITION_CATALOG,
  ENDPOINT_COUNTRIES
} from '../config'

const transformJSONToGETParameters = (JSONParameters) => {
  let GETParameters = '?'
  if (JSONParameters.transform === true) {
    GETParameters += 'transform=1&'
  }
  if (JSONParameters.order) {
    const {column, direction} = JSONParameters.order
    GETParameters += `order=${column},${direction || 'ASC'}&`
    if (JSONParameters.page) {
      const {number, itemsPerPage} = JSONParameters.page
      GETParameters += `page=${number || 1},${itemsPerPage || 50}&`
    }
  }
  GETParameters += `satisfy=${JSONParameters.satisfy || 'all'}&`
  JSONParameters.columns &&
  (GETParameters += `columns=${JSONParameters.columns}&`)
  JSONParameters.filters &&
  JSONParameters.filters.map(currentFilter => {
    if (currentFilter && currentFilter.value !== ',') {
      GETParameters += (
        'filter[]=' +
        currentFilter.property + ',' +
        currentFilter.matchType + ','
      )
      if (Array.isArray(currentFilter.value)) {
        GETParameters += currentFilter.value.join('||')
      } else {
        GETParameters += currentFilter.value
      }
      GETParameters += '&'
    }
  })
  return GETParameters
}

class ApiService {
  /**
   * Search for exhibition service
   * @param {object} JSONParameters - options object
   * @param {array} JSONParameters.filters - filters (array of { property, matchType, value:string|number|array } )
   * @param {object} JSONParameters.order - order { column, direction }
   * @param {object} JSONParameters.page - page { page, itemPerPage }
   * @param {string} JSONParameters.satisfy - satisfy (all || any)
   * @param {string} JSONParameters.columns - columns (comma separated column name)
   * @returns Promise
   * @memberOf ApiService
   */
  searchExhibition (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitionSectionCSV (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_SECTION_CSV + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitionSection (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_SECTION + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitionAddress (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_ADDRESS + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitor (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITOR + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  getExhibitionGroupType (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_GROUP_TYPE + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  getExhibGroups (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_GROUP + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  getCountries (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_COUNTRIES + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitedWorkCSV (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITED_WORK_CSV + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  searchExhibitedWork (JSONParameters) {
    const GETParameters = transformJSONToGETParameters(JSONParameters)
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITED_WORK + GETParameters)
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
  getCatalog (id) {
    return fetch(API_URL + ENDPOINT_VISU_EXHIBITION_CATALOG + '/' + id + '?transform=1')
      .then(response => {
        if (response.status >= 400) {
          throw new Error('Bad response from server')
        }
        return response.json()
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export const Api = new ApiService()

export default Api



// WEBPACK FOOTER //
// ./src/services/api.js